module.exports = __webpack_public_path__ + "static/img/g_2_tick.e757517b.png";